import { BillingTranslate } from './billingTranslate.model';

const billingTranslatePTBR: BillingTranslate = {
  quotaLimitModal: {
    title: 'Limite do plano atingido',
    description:
      'Você usou {{current}} de {{limit}} {{resource}} disponíveis no seu plano. Faça upgrade pra continuar criando.',
    usage: '{{current}} de {{limit}} {{resource}}',
    viewPlans: 'Ver planos',
    close: 'Fechar',
    closeAriaLabel: 'Fechar modal de limite',
  },
  upgradePromptModal: {
    title: 'Recurso premium',
    description:
      '{{feature}} está disponível nos planos Studio e Coletivo. Faça upgrade pra desbloquear.',
    knowPlans: 'Conhecer planos',
    close: 'Fechar',
    closeAriaLabel: 'Fechar modal de upgrade',
  },
  statusBanner: {
    trialing_one: 'Seu trial termina em 1 dia. Assine pra manter o acesso.',
    trialing_other:
      'Seu trial termina em {{daysLeft}} dias. Assine pra manter o acesso.',
    pastDue:
      'Sua última cobrança falhou. Atualize seu cartão pra evitar suspensão.',
    suspended:
      'Sua assinatura está suspensa. Regularize o pagamento pra voltar a acessar seus dados.',
    nearLimit:
      'Você já usou {{current}} de {{limit}} leads ativos. Faça upgrade pra liberar mais.',
    cancelPending:
      'Sua assinatura termina em {{date}}. Depois disso, você volta automaticamente pro plano Solo.',
    cancelPendingCta: 'Reverter',
    cta: {
      seePlans: 'Ver planos',
      updatePayment: 'Atualizar pagamento',
    },
  },
  page: {
    title: 'Assinatura',
    placeholderText:
      'Funcionalidade em construção. Em breve você poderá gerenciar seu plano por aqui.',
    backCta: 'Voltar',
  },
  resources: {
    leads: 'leads',
    users: 'usuários',
    eventStatuses: 'colunas',
  },
  features: {
    customEventStatuses: 'Colunas personalizadas no quadro de eventos',
    fullDashboard: 'Dashboard completo',
    birthPhotographerMode: 'Modo fotógrafo de parto',
    csvExport: 'Exportação em CSV',
    pdfReports: 'Relatórios em PDF',
    prioritySupport: 'Suporte prioritário',
    nfse: 'Emissão de NFS-e',
  },
  planChoice: {
    title: 'Escolha seu plano',
    subtitle: 'Comece grátis ou experimente o Studio por 14 dias sem cobrança.',
    cards: {
      solo: {
        name: 'Solo',
        price: 'Grátis',
        cta: 'Começar grátis',
        features: [
          'Até 15 leads ativos',
          '1 usuário',
          'Quadro de eventos com colunas padrão',
          'Suporte por e-mail',
        ],
      },
      studio: {
        name: 'Studio',
        price: 'R$ 29,90/mês',
        trialCta: 'Iniciar trial de 14 dias',
        subscribeCta: 'Assinar agora',
        features: [
          'Leads ilimitados',
          'Até 5 usuários',
          'Colunas personalizadas no quadro',
          'Dashboard completo',
          'Exportação em CSV',
          'Relatórios em PDF',
        ],
      },
      collective: {
        name: 'Coletivo',
        price: 'R$ 79,90/mês',
        cta: 'Assinar Coletivo',
        features: [
          'Tudo do Studio',
          'Usuários ilimitados',
          'Modo fotógrafo de parto',
          'Emissão de NFS-e',
          'Suporte prioritário',
        ],
      },
    },
    highlightedBadge: 'Mais escolhido',
    coupon: {
      label: 'Tem um cupom?',
      placeholder: 'EX: LANCAMENTO50',
      applyCta: 'Aplicar',
      removeCta: 'Remover',
      selectPlanFirst: 'Nenhum plano pago disponível pra validar o cupom.',
      percentOff: '{{percent}}% de desconto',
      freeMonths_one: '1 mês grátis',
      freeMonths_other: '{{count}} meses grátis',
      applied: 'Cupom {{code}} aplicado',
      invalidError: 'Cupom inválido. Verifique o código.',
    },
  },
  billingPage: {
    title: 'Assinatura',
    activeCoupon: {
      title: 'Cupom {{code}} ativo',
      percentOff_one: '{{percent}}% de desconto na próxima fatura',
      percentOff_other:
        '{{percent}}% de desconto nas próximas {{count}} faturas',
      freeMonths: 'Meses grátis até {{date}}',
    },
    status: {
      title: 'Status da assinatura',
      nextChargeLabel: 'Próxima cobrança',
      priceLabel: 'Valor',
      emptyValue: '—',
      perMonth: '/mês',
      perYear: '/ano',
      trialCountdown_one: 'Trial termina em 1 dia',
      trialCountdown_other: 'Trial termina em {{count}} dias',
      badge: {
        trialing: 'Em trial',
        active: 'Ativa',
        pastDue: 'Pagamento atrasado',
        suspended: 'Suspensa',
        canceled: 'Cancelada',
      },
    },
    changePlan: {
      title: 'Mudar de plano',
      subtitle:
        'Faça upgrade pra liberar mais recursos ou volte pra um plano menor.',
      cta: {
        current: 'Plano atual',
        upgrade: 'Fazer upgrade',
        downgrade: 'Fazer downgrade',
      },
      features: {
        unlimitedLeads: 'Leads ilimitados',
        maxLeads_one: 'Até 1 lead ativo',
        maxLeads_other: 'Até {{count}} leads ativos',
        maxUsers_one: '1 usuário',
        maxUsers_other: 'Até {{count}} usuários',
      },
    },
    invoices: {
      title: 'Histórico de faturas',
      emptyState: 'Nenhuma fatura ainda',
      loading: 'Carregando faturas…',
      columns: {
        date: 'Data',
        amount: 'Valor',
        status: 'Status',
        invoice: 'Fatura',
        nf: 'NF',
        actions: 'Ações',
      },
      status: {
        paid: 'Paga',
        pending: 'Pendente',
        overdue: 'Vencida',
        canceled: 'Cancelada',
        refunded: 'Estornada',
      },
      pagination: {
        previous: 'Anterior',
        next: 'Próxima',
        page: 'Página {{page}} de {{totalPages}}',
      },
      downloadInvoice: 'Baixar fatura',
      downloadNf: 'Baixar NF',
    },
    paymentMethod: {
      title: 'Método de pagamento',
      description: 'Gerencie seu cartão no painel do Asaas.',
      updateCta: 'Trocar cartão',
    },
  },
  upgradeConfirmModal: {
    title: 'Confirmar upgrade',
    creditFromCurrent: 'Crédito do plano atual',
    prorateNewPlan: 'Valor proporcional do novo plano',
    totalToCharge: 'Total a cobrar agora',
    nextCycleAt: 'Próximo ciclo cobra em {{date}}.',
    confirmCta: 'Confirmar upgrade',
    cancelCta: 'Cancelar',
    loading: 'Carregando preview…',
  },
  downgradeBlockedModal: {
    title: 'Você tem mais uso que o novo plano permite',
    leadExcess_one:
      'Você tem {{active}} leads ativos. O plano novo aceita até {{limit}}. Desative {{reduceBy}} lead pra fazer downgrade agora.',
    leadExcess_other:
      'Você tem {{active}} leads ativos. O plano novo aceita até {{limit}}. Desative {{reduceBy}} leads pra fazer downgrade agora.',
    userExcess_one:
      'Você tem {{active}} usuários. O plano novo aceita até {{limit}}. Remova {{reduceBy}} usuário pra fazer downgrade agora.',
    userExcess_other:
      'Você tem {{active}} usuários. O plano novo aceita até {{limit}}. Remova {{reduceBy}} usuários pra fazer downgrade agora.',
    deactivateLeadsCta: 'Gerenciar leads',
    scheduleCta: 'Agendar pro fim do ciclo',
  },
  couponInput: {
    label: 'Cupom de desconto',
    placeholder: 'EX: LANCAMENTO50',
    applyCta: 'Aplicar',
    confirmCta: 'Confirmar cupom',
    redeemCta: 'Resgatar',
    validating: 'Validando…',
    selectPlanFirst: 'Selecione um plano primeiro.',
    appliedSuccess: 'Cupom aplicado.',
    validateError: 'Erro ao validar cupom.',
    conflictError: 'Este cupom já foi utilizado ou está esgotado.',
    percentOff: '{{percent}}% de desconto',
    freeMonths_one: '1 mês grátis',
    freeMonths_other: '{{count}} meses grátis',
    invoicesScope_one: ' por 1 fatura',
    invoicesScope_other: ' por {{count}} faturas',
    totalWithDiscount: 'Total com desconto:',
    redeemedFreeMonths_one:
      '1 mês grátis aplicado — próxima cobrança em {{date}}',
    redeemedFreeMonths_other:
      '{{count}} meses grátis aplicados — próxima cobrança em {{date}}',
    redeemedPercentOff_one: '{{percent}}% de desconto na próxima fatura',
    redeemedPercentOff_other:
      '{{percent}}% de desconto nas próximas {{count}} faturas',
  },
  collectDocumentModal: {
    title: 'Confirme seu CPF ou CNPJ',
    subtitle:
      'Precisamos do seu documento pra emitir a cobrança. Ele fica armazenado de forma segura e só é usado pra fins fiscais.',
    documentTypeLabel: 'Tipo de documento',
    documentNumberLabel: 'Número do documento',
    cpfOption: 'CPF (pessoa física)',
    cnpjOption: 'CNPJ (pessoa jurídica)',
    typeRequired: 'Selecione o tipo de documento.',
    invalidDocument: 'Documento inválido. Verifique os dígitos.',
    saveCta: 'Salvar e continuar',
    cancelCta: 'Cancelar',
    toasts: {
      saveSuccess: 'Documento salvo com sucesso.',
      saveError: 'Não foi possível salvar o documento. Tente novamente.',
    },
  },
  cancelButton: {
    label: 'Cancelar assinatura',
  },
  cancelModal: {
    title: 'Cancelar assinatura',
    commentLabel: 'Quer compartilhar mais detalhes? (opcional)',
    commentPlaceholder: 'Conte o que motivou sua decisão…',
    commentRequired: 'Conta um pouco mais pra gente entender melhor.',
    continueCta: 'Continuar',
    backCta: 'Voltar',
    cancelCta: 'Cancelar',
    confirmCta: 'Confirmar cancelamento',
    reasons: {
      price: 'Está caro pra mim',
      notUsing: 'Não estou usando',
      switched: 'Mudei pra outra ferramenta',
      other: 'Outro motivo',
    },
    step2: {
      message:
        'Sua assinatura continuará ativa até {{date}}. Após essa data, volta automaticamente pro plano Solo.',
    },
  },
  errors: {
    unauthorized: 'Você não tem permissão pra acessar esta página.',
    loadSubscriptionFailed:
      'Não foi possível carregar os dados da sua assinatura. Tente novamente em instantes.',
    retry: 'Tentar de novo',
  },
  toasts: {
    startFreePlanError:
      'Não foi possível ativar o plano gratuito. Tente novamente.',
    startTrialError: 'Não foi possível iniciar o trial. Tente novamente.',
    createCheckoutError:
      'Não foi possível abrir o checkout. Tente novamente em instantes.',
    subscriptionAlreadyExists:
      'Este estúdio já possui uma assinatura ativa. Gerencie seu plano por aqui.',
    checkoutSuccess: 'Pagamento processado! Sua assinatura está ativa.',
    updatePaymentMethodError:
      'Não foi possível abrir o gerenciador de cartões. Tente novamente.',
    upgradeSuccess: 'Plano atualizado! Cobrança proporcional já processada.',
    upgradeError: 'Não foi possível concluir o upgrade. Tente novamente.',
    downgradeSuccess: 'Plano alterado. Novo limite já está ativo.',
    downgradeScheduled:
      'Downgrade agendado pro fim do ciclo. Você continua no plano atual até lá.',
    downgradeError: 'Não foi possível concluir o downgrade. Tente novamente.',
    cancelScheduled:
      'Cancelamento agendado pro fim do ciclo. Você pode reverter a qualquer momento até lá.',
    cancelError: 'Não foi possível cancelar a assinatura. Tente novamente.',
    reactivateSuccess:
      'Sua assinatura foi reativada. Você continua com acesso completo.',
    reactivateError: 'Não foi possível reativar a assinatura. Tente novamente.',
    planNotAvailable: 'Plano indisponível no momento.',
    loadPlansError:
      'Não foi possível carregar os planos pagos. Tente novamente em instantes.',
  },
};

export default billingTranslatePTBR;
